







import {Vue, Component, Watch} from 'vue-property-decorator';
import DimmedArea from '@/components/common/DimmedArea.vue';
import {getMetaTitle} from '@/utils/formatUtils';
import { SESSION_INITIALIZE, AUTH_TOKEN_REFRESHED } from '@/const/words/cookie';
import { setToken } from '@/utils/dataUtils';

import { namespace, State } from 'vuex-class';
import { getCookie } from './utils/cookieUtils';
import { deleteAuthInfoToLogOut } from '@/utils/authUtils';
import { Mall } from 'ncp-api-supporter';
import { hyundaiMallNos, kiaMallNos } from '@/const/mall';

const orderEnumsModule = namespace('orderEnums');

@Component({
  metaInfo() {
    return (this as any).viewTitle;
  },
  components: {DimmedArea}
})
export default class App extends Vue {
  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  @orderEnumsModule.Action('fetchOrderConfigsEnums')
  private readonly fetchOrderConfigsEnums!: () => Promise<void>;

  private shouldLoadCss = true;

  private async loadCss() {
    if (this.shouldLoadCss) {
      if (this.$route.path !== '/design/editor') {
        import('@/assets/css/import.css')
          .then(() => {
            this.shouldLoadCss = false;
          })
      } else {
        this.shouldLoadCss = false;
      }
    }
  }

  async created() {
    this.$router.onReady(() => {
      this.loadCss();
    });

    if (!getCookie(SESSION_INITIALIZE)) {
      deleteAuthInfoToLogOut();
    } else {
      await this.fetchOrderConfigsEnums();
    }

    window.$i18n = this.$i18n;
    window.$t = this.$t;
  }
  mounted() {
    window.$i18n = this.$i18n;
    window.$t = this.$t;
    
    // message 이벤트 리스너 추가
    window.addEventListener('message', this.handleReceiveMessage);
  }

  beforeDestroy() {
    // 컴포넌트 제거 시 이벤트 리스너 해제
    window.removeEventListener('message', this.handleReceiveMessage);
  }

  private handleReceiveMessage(e: MessageEvent) {
    // AUTH_TOKEN_REFRESHED 메시지 처리
    if (e.data?.type === AUTH_TOKEN_REFRESHED) {
      const { accessToken, refreshToken, autoLogoutMin } = e.data.data ?? {};

      if (accessToken && refreshToken) {
        setToken(accessToken, refreshToken, autoLogoutMin);
      }
    }
  }
  private get viewTitle() {
    if (this.$route.name) {
      return {
        title: getMetaTitle(this, this.$route.name)
      };
    } else {
      return {
        title: getMetaTitle(this)
      };
    }
  }

  @Watch('malls')
  private getFaviconPath() {
    if (this.malls.some(({ mallNo }) => hyundaiMallNos.includes(mallNo))) {
      this.changeFavicon('/hyundai_favicon.ico?t=20240925');

      return;
    }

    if (this.malls.some(({ mallNo }) => kiaMallNos.includes(mallNo))) {
      this.changeFavicon('/kia_favicon.ico?t=20250113');

      return;
    }

    return;
  }

  changeFavicon(iconUrl) {
    const head = document.querySelector('head');
    const oldLink = document.querySelector('link[rel*="icon"]');
    if (oldLink) {
      oldLink.remove();
    }

    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.href = iconUrl;
    head.insertAdjacentElement('afterbegin', newLink);
  }
}
